<template>
    <WizardTabWithSidebar
        sidebar-background-image="https://superangels.club/wp-content/uploads/2020/07/ESAC_2020_invest_connect_smart_mobility_72dpi_1600x1200_landscape_BACKGROUND_ONLY.jpg">
        <template #main>
            <WizardHeader title="Managers and Beneficial Owners Overview" :icon="UsersIcon"></WizardHeader>
            <div class="px-4 py-3 sm:px-6">
                <p class="text-md pb-2 font-semibold text-gray-700">
                    {{ $t('legal_account_manager_beneficial_owner.manager') }}
                </p>
                <div class="overflow-hidden border border-gray-200 bg-white shadow sm:col-span-1 sm:rounded-md">
                    <ManagersList show-edit :managers="state.legalProfile.managers" @edit="editManager"></ManagersList>
                </div>

                <div class="flex w-full justify-end pt-4">
                    <BaseButtonPrimary
                        :disabled="state.legalProfile.managers.length >= 2"
                        size="lg"
                        @click="createNewManager()">
                        <PlusIcon class="mr-2 w-6"></PlusIcon>
                        Add another Managing Director
                    </BaseButtonPrimary>
                </div>
                <p class="text-md pb-2 font-semibold text-gray-700">
                    {{ $t('legal_account_manager_beneficial_owner.beneficial_owner') }}
                </p>
                <div class="overflow-hidden border border-gray-200 bg-white shadow sm:col-span-1 sm:rounded-md">
                    <BeneficialOwnersList
                        v-if="state.legalProfile.beneficial_owners.length > 0"
                        :beneficial-owners="state.legalProfile.beneficial_owners"></BeneficialOwnersList>
                    <div v-else class="p-4">
                        <p class="text-center text-base text-gray-500">
                            {{ $t('legal_account_manager_beneficial_owner.no_beneficial_owners') }}
                        </p>
                    </div>
                </div>

                <div class="flex w-full justify-end pt-4">
                    <BaseButtonPrimary
                        :disabled="state.legalProfile.beneficial_owners.length >= 4"
                        size="lg"
                        @click="navigateToTab('legal_additional_ubo_personal')">
                        <PlusIcon class="mr-2 w-6"></PlusIcon>
                        Add another Beneficial Owner
                    </BaseButtonPrimary>
                </div>
            </div>
        </template>
        <template #nextButton>
            <BaseButtonPrimary
                :loading="usePersonalAccountDataState().saving"
                :disabled="usePersonalAccountDataState().saving || formState.hasValidationErrors"
                size="lg"
                @click="submit()"
                >{{ $t('widget.save') }}
            </BaseButtonPrimary>
        </template>
        <template #previousButton>
            <BaseButtonMuted size="lg" @click="navigateToPreviousTab()">{{ $t('widget.back') }}</BaseButtonMuted>
        </template>

        <template #sidebar>
            <p class="pb-2 pb-2 text-base text-gray-800">
                {{ $t('esac_widget_sidebar.legal_managers_ubo_overview') }}
            </p>
        </template>
    </WizardTabWithSidebar>
</template>

<script setup lang="ts">
import WizardTabWithSidebar from '../../WizardTabWithSidebar.vue'
import WizardHeader from '../../WizardHeader.vue'
import BaseButtonPrimary from '../../../base/BaseButtonPrimary.vue'
import BaseButtonMuted from '../../../base/BaseButtonMuted.vue'
import { usePersonalAccountDataState } from '../../../../utilities/account/useAccountDataPersonal'
import { useLegalAccountFormState } from '../../../../utilities/account/useAccountFormLegal'
import { inject, onMounted } from 'vue'
import { PlusIcon, UsersIcon } from '@heroicons/vue/outline'
import { useLegalAccountDataState } from '../../../../utilities/account/useAccountDataLegal'
import ManagersList from '../../../account/legal/managers/ManagersList.vue'
import BeneficialOwnersList from '../../../account/legal/beneficialOwners/BeneficialOwnersList.vue'
import { currentNewManager } from './manager'

const formState = useLegalAccountFormState()
const state = useLegalAccountDataState()
const { navigateToNextTab, navigateToPreviousTab, navigateToTab } = inject('navigation')

function editManager(manager: any) {
    currentNewManager.value = manager
    navigateToTab('legal_additional_manager_personal')
}
function createNewManager() {
    currentNewManager.value = null
    navigateToTab('legal_additional_manager_personal')
}

onMounted(async () => {
    await state.fetchAccountData()
})

async function submit() {
    // const { valid } = await formState.currentForm.validate()
    // if (valid) {
    //     await formState.submit()
    navigateToNextTab()
    // }
}
</script>

<style scoped></style>
